import { useEffect } from 'react';

const log = (...args) => {
  console.log('SEO WARNING!', ...args);
};

const SeoHelper = () => {
  useEffect(() => {
    const duplicatedTitles = () => {
      const titles = document.querySelectorAll('h1');

      if (titles.length > 1) {
        log('More than 1 H1 tag used on the page!', titles);
      }
      if (titles.length === 0) {
        log('No H1 title on the page');
      }
    };
    const noImageAlt = () => {
      const images = Array.from(document.querySelectorAll('img'));

      const withoutAlt = images.filter((im) => {
        return !im.getAttribute('alt');
      });
      if (withoutAlt.length > 0) {
        log('<img /> tags without alt attribute found!', withoutAlt);
      }
    };
    const analyze = () => {
      duplicatedTitles();
      noImageAlt();
    };
    const iid = setInterval(analyze, 10_000);
    const tid = setTimeout(analyze, 1_000);

    return () => {
      clearInterval(iid);
      clearTimeout(tid);
    };
  }, []);

  return null;
};

export default SeoHelper;
